import { render, staticRenderFns } from "./living_pc_preview.vue?vue&type=template&id=35d79096&scoped=true&"
import script from "./living_pc_preview.vue?vue&type=script&lang=js&"
export * from "./living_pc_preview.vue?vue&type=script&lang=js&"
import style0 from "./living_pc_preview.vue?vue&type=style&index=0&id=35d79096&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d79096",
  null
  
)

export default component.exports